<template>
  <fragment>
    <div class="filter-section">
      <div class="filter-section-cont">
        <div>
          <div class="drawresultw" v-on:click="selectFilter('0')">
            <input type="radio" value="0" v-model="drawtype">
            <span>{{ $t('result_page.draw_result') }}</span>
          </div>
          <div class="l1resultw" v-on:click="selectFilter('1')">
            <input type="radio" value="1" v-model="drawtype">
            <span>{{ $t('result_page.draw_result_l1') }}</span>
          </div>
          <div class="l2resultw" v-on:click="selectFilter('2')">
            <input type="radio" value="2" v-model="drawtype">
            <span>{{ $t('result_page.draw_result_l2') }}</span>
          </div>
          <div class="l3resultw" v-on:click="selectFilter('3')">
            <input type="radio" value="3" v-model="drawtype">
            <span>{{ $t('result_page.draw_result_l3') }}</span>
          </div>
          <div class="l4resultw" v-on:click="selectFilter('4')">
            <input type="radio" value="4" v-model="drawtype">
            <span>{{ $t('result_page.draw_result_l4') }}</span>
          </div>
          <div class="l5resultw" v-on:click="selectFilter('5')">
            <input type="radio" value="5" v-model="drawtype">
            <span>{{ $t('result_page.draw_result_l5') }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="mobileoverflow" style="width: 100%;">
      <table class="tablestyle">
        <thead>
          <tr>
            <th>{{ $t('result_page.draw_result_id') }}</th>
            <th style="width: 95px; min-width: 95px; max-width: 95px;">{{ $t('datetime') }}</th>
            <th>{{ $t('total_sum') }}</th>
            <th class="info-td-o">{{ $t('B/S') }}</th>
            <th class="info-td-o">{{ $t('O/E') }}</th>
            <th class="info-td-o">{{ $t('R/B') }}</th>
            <th class="info-td-o">{{ $t('H/L') }}</th>
            <th class="info-td-o">{{ $t('S/S/A/W') }}</th>
            <th class="othersdata draw-results" v-if="drawtype === '0'" >
              {{ $t('result_page.draw_result') }}
            </th>
            <th class="othersdata l1-results" v-if="drawtype !== '0'">
              {{ $t(`L${drawtype}`) }} <br/> {{ $t('sum') }}
            </th>
            <th class="othersdata l1-results info-td-o" v-if="drawtype !== '0'">
              {{ $t(`L${drawtype}`) }} <br/> {{ $t('B/S') }}
            </th>
            <th class="othersdata l1-results info-td-o" v-if="drawtype !== '0'">
              {{ $t(`L${drawtype}`) }} <br/> {{ $t('O/E') }}
            </th>
            <th class="othersdata l1-results info-td-o" v-if="drawtype !== '0'">
              {{ $t(`L${drawtype}`) }} <br/> {{ $t('R/B') }}
            </th>
            <th class="othersdata l1-results info-td-o" v-if="drawtype !== '0'">
              {{ $t(`L${drawtype}`) }} <br/> {{ $t('H/L') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <Pass
            v-for="(column, index) in data"
            :key="index"
            :metadata="getDataDetail(column)"
          >
            <tr
              slot-scope="{ metadata }"
              v-if="metadata.resultRaw !== undefined"
            >
              <td>{{ column.id }}</td>
              <td>{{ column.endAt }} </td>
              <td>{{ metadata.mainTotal }} </td>
              <td><BigSmall :value="metadata.bigSmall" /></td>
              <td><OddEven :value="metadata.oddEven" /></td>
              <td><RedBlack :value="metadata.redBlack" /></td>
              <td><HighLow :value="metadata.highLow" /></td>
              <td><Season :value="metadata.season" /></td>
              <td v-if="drawtype === '0'">{{ metadata.resultRaw.result.join() }} </td>
              <td v-if="drawtype !== '0'" class="othersdata l1-results" >
                {{ metadata[`L${drawtype}total`] }}
              </td>
              <td v-if="drawtype !== '0'" class="othersdata l1-results info-td-o" >
                <OddEven :value="metadata[`L${drawtype}oddEven`]" />
              </td>
              <td v-if="drawtype !== '0'" class="othersdata l1-results info-td-o" >
                <OddEven :value="metadata[`L${drawtype}oddEven`]" />
              </td>
              <td v-if="drawtype !== '0'" class="othersdata l1-results info-td-o" >
                <RedBlack :value="metadata[`L${drawtype}redBlack`]" />
              </td>
              <td v-if="drawtype !== '0'" class="othersdata l1-results info-td-o" >
                <HighLow :value="metadata[`L${drawtype}highLow`]" />
              </td>
            </tr>
          </Pass>
        </tbody>
      </table>
    </div>
  </fragment>
</template>

<script>
import { calculateScore } from '@handlers/atom/result.js';
import BigSmall from '@components/content/result/big-small.vue';
import OddEven from '@components/content/result/odd-even.vue';
import RedBlack from '@components/content/result/red-black.vue';
import HighLow from '@components/content/result/high-low.vue';
import Season from '@components/content/result/season.vue';

const Pass = {
  render() {
    return this.$scopedSlots.default(this.$attrs)
  }
}

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    Pass, BigSmall, OddEven, RedBlack, HighLow, Season,
  },
  props: {
    id: Number,
    endAt: String,
    data: Array,
  },
  data() {
    return {
      drawtype: '0',
    }
  },
  methods: {
    getDataDetail: function(column){
      if(column.resultRaw === undefined){
        return {};
      }
      const score = calculateScore(column);
      // console.log('score', score);
      return score;
    },
    selectFilter(event) {
      this.drawtype = event;
    },
  }
}
</script>

